export const LISTONCE_EMAIL_TEMPLATE = {
  to: 'support@listonce.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello ListOnce

Could you please enable Snug as an upload destination for our agency for the ListOnce Account(s):

- [Enter your Agency ID here]

Please assign the ListOnce Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
